import "core-js/modules/es.array.map";
import "core-js/modules/es.parse-int";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
import box from '../box/box';

var getCharFromCode = function getCharFromCode(code) {
  return parseInt(code, 16);
};

var replaceEncodedCharacters = function replaceEncodedCharacters(str) {
  if (str === null) {
    return null;
  } // Decode escaped unicode characters
  // Decode ampersand
  // Decode registered trademark symbol
  // replace /x00 ASCII encoded chars


  return box(str).map(function (s) {
    return s.replace(/\\\\u/gi, "\\u");
  }).map(function (s) {
    return s.replace(/\\u0026/gi, '&');
  }).map(function (s) {
    return s.replace(/&reg;/gi, '®');
  }).fold(function (s) {
    return s.replace(/\\x([0-9A-Fa-f]{2})/g, getCharFromCode);
  });
};

export default replaceEncodedCharacters;